import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
// import store from './store'
import { createPinia } from 'pinia'
import store from './store/store'  // Import the Vuex store

// Library Components
import VueSweetalert2 from 'vue-sweetalert2'
import VueApexCharts from 'vue3-apexcharts'
import BootstrapVue3 from 'bootstrap-vue-3'
import CounterUp from '@/assets/vendor/vue3-autocounter'
import 'aos/dist/aos.css'
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

// Custom Components & Directives
import globalComponent from './plugins/global-components'
import globalDirective from './plugins/global-directive'
import globalMixin from './plugins/global-mixin'

//i18n
import i18n from './i18n'

//axios
import axiosPlugin  from '@/plugins/axios'

//toast
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

//country & state selection
import vueCountryRegionSelect from 'vue3-country-region-select'

//multi-step form
import Vue3FormWizard from 'vue3-form-wizard'
import 'vue3-form-wizard/dist/style.css'

//vue3-tel-input
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'

//quill
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

//excel
import JsonExcel from "vue-json-excel3";

require('waypoints/lib/noframework.waypoints.min')

const app = createApp(App)
const pinia = createPinia()

app.use(router)
app.use(pinia)

// Library Components
app.use(VueSweetalert2)
app.use(VueApexCharts)
app.use(BootstrapVue3)
app.component('counter-up', CounterUp)

// Custom Components & Directives
app.use(globalComponent)
app.use(globalDirective)
app.mixin(globalMixin)

//i18n
app.use(i18n)

//axios
app.use(axiosPlugin, { baseUrl: process.env.VUE_APP_API_BASE_URL });

//toast
app.use(ToastPlugin);

//country & state
app.use(vueCountryRegionSelect);

//multi-form
app.use(Vue3FormWizard);

//vue3-tel-input
app.use(VueTelInput)

//quill
app.component('QuillEditor', QuillEditor)

//excel
app.component('DownloadExcel', JsonExcel)

app.use(store)

app.mount('#app')

export default app
